import { useAuth } from '@/lib/auth/use-auth.js';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

export const Route = createFileRoute('/logout')({
  component: LogoutPage,
});

function LogoutPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    auth.logout().finally(() => {
      void navigate({ to: '/login', replace: true });
    });
  }, [auth, navigate]);

  return null;
}
